window.theme = window.theme || {};

function ordinal(n) {
  var s = ["th", "st", "nd", "rd"];
  var v = n%100;
  return (s[(v-20)%10] || s[v] || s[0]);
}

(function(){
  const launchTime = '2022-09-29T12:00';
  
  // window.theme.launchTime = "Translation missing: en.products.general.on_sale_date";

  // console.log('launch:', launchTime);
    
  window.theme.readyToLaunch = () => {
    const current = luxon.DateTime.local().setZone("Australia/Adelaide");
    const launch = luxon.DateTime.fromISO(launchTime, { zone: "Australia/Adelaide" }).setLocale('en-au');
    
    // console.log(current.toFormat('X'), launch.toFormat('X'));
    
    if (current.toFormat('X') - launch.toFormat('X') > 0) {
      document.getElementById('showTickets').classList.remove('hidden');
      document.getElementById('hideTickets').remove();  
    } else {    
      document.getElementById('showTickets').remove();
      const el = document.getElementById('hideTickets');
      const strong = el.querySelector('strong');
      //strong.innerHTML = launch.toLocaleString(luxon.DateTime.DATE_FULL);
      // strong.innerHTML = launch.toFormat('MMMM d yyyy ha ZZZZ');
      const rep = ordinal(launch.toFormat('d'));
      strong.innerHTML = launch.toFormat('EEEE d! MMMM yyyy').replace('!', rep);
     
      el.classList.remove('hidden');      
    }
  };
})();

